import { OptionalTabIndex } from "@multiweb/types/react";

/**
 * Pomocný typ pro KeyboardNavigationContext a FocusableItemWrapper. Používá se
 * pro registraci komponent dostupných klávesnicí v navigačním kontextu.
 */
export type NavigableComponentProps = {
    /** Identifikátor itemu */
    id: string;
    /** Jestli je element zaměřitelný */
    focusable: boolean;
};

/**
 * Pomocný typ pro návratovou hodnotu z getNavigationData pro KeyboardNavigationContext.
 */
export type NavigationData = {
    /** Hodnota tab indexu. */
    tabIndex: OptionalTabIndex;
    /** Příznak, zda má být komponenta zaměřená. */
    isFocused: boolean;
};

/**
 * Pomocný enum pro nastavení módu, podle kterého se řídí algoritmus pro výběr pozice zaměřeného prvku.
 */
export enum PositionSelectionMode {
    /** Při ztrátě zaměřitelnosti aktuálně zaměřeného prvku se zaměří první možný prvek. Může vést ke ztrátě pozice. */
    default,
    /** Při změně pozice nebo ztrátě aktuálně zaměřeného prvku se zaměření předá prvku, který se dostal na jeho místo v seznamu. */
    holdPosition,
    /** Při změně pozice nebo ztrátě aktuálně zaměřeného prvku se zaměření předá prvnímu zaměřitelnému prvku. */
    preferFirst,
}
